import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List } from 'immutable'
import { H3, HEADING_TYPES } from '../Heading/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import Button, { TYPES } from '../Button/index'
import {
  URL_PLAYLIST_WATCH_HISTORY,
  URL_PLAYLIST_PURCHASES_VIDEOS,
  URL_PLAYLIST_PURCHASES_EBOOKS,
  URL_PLAYLIST_BONUS_VIDEOS,
  URL_PLAYLIST_BONUS_EBOOKS,
} from '../../services/url/constants'
import { PLAYLIST_TYPE_HISTORY } from '../../services/playlist/index'
import Timer from '../Icon/icons/Timer/index'
import Clock from '../Icon/icons/Clock/index'
import Star from '../Icon/icons/Star/index'
import Stack from '../Icon/icons/Stack/index'
import Film from '../Icon/icons/Film/index'
import Book from '../Icon/icons/Book/index'
import Plus from '../Icon/icons/Plus/index'
import MyLibraryNavItem from './MyLibraryNavItem'

const MyLibraryNav = (props) => {
  const {
    defaultPlaylists,
    customPlaylists,
    staticText,
    location,
    onCreateClick,
    title,
    userPurchases,
    userBonuses,
  } = props

  const [expanded, setExpanded] = useState(false)
  const hasBonusVideos = userBonuses.contentList.size > 0
  const hasBonusEBooks = userBonuses.assetsList.size > 0
  const hasPurchasesVideos = userPurchases.contentList.size > 0
  const hasPurchasesEBooks = userPurchases.assetsList.size > 0

  const handleItemClick = () => {
    setExpanded(false)
  }

  return (
    <div className="my-library__nav">
      <div className="my-library__nav-collapsible" onClick={() => setExpanded(!expanded)}>
        <div className="my-library__nav-heading">
          <H3 as={HEADING_TYPES.H5}>
            {expanded ? staticText.get('libraryNavTitle') : title || staticText.get('libraryNavTitle')}
          </H3>
        </div>
        <IconV2 type={expanded ? ICON_TYPES.CHEVRON_UP : ICON_TYPES.CHEVRON_DOWN} />
      </div>
      <div className={`my-library__nav-content ${expanded ? 'my-library__nav-content--expanded' : ''}`}>
        <div className="my-library__nav-heading">
          <H3 as={HEADING_TYPES.H5}>
            {staticText.get('playlistsNavTitle')}
          </H3>
        </div>

        <ul className="my-library__nav-list">
          {defaultPlaylists.map((item) => (
            <MyLibraryNavItem
              key={item.get('playlistType')}
              url={item.get('url')}
              onClick={handleItemClick}
              icon={item.get('playlistType') === 'default' ? <Clock /> : <Star /> }
              text={item.get('playlistName')}
              location={location}
            />
          ))}
          <MyLibraryNavItem
            key={PLAYLIST_TYPE_HISTORY}
            url={URL_PLAYLIST_WATCH_HISTORY}
            onClick={handleItemClick}
            icon={<Timer />}
            text={staticText.get('watchHistoryTitle')}
            location={location}
          />
          {customPlaylists.map((item) => (
            <MyLibraryNavItem
              key={item.get('playlistType')}
              url={item.get('url')}
              onClick={handleItemClick}
              icon={<Stack />}
              text={item.get('playlistName')}
              location={location}
            />
          ))}

          <li className="my-library__nav-create">
            <Button type={TYPES.GHOST} className="my-library__nav-create-button" onClick={onCreateClick}>
              <Plus className="my-library__nav-create-button-icon" />
              <span className="my-library__nav-create-button-text">
                {staticText.get('createNew')}
              </span>
            </Button>
          </li>
        </ul>

        {(hasBonusVideos || hasBonusEBooks)
          && <>
            <div className="my-library__nav-heading">
              <H3 as={HEADING_TYPES.H5}>
                {staticText.get('bonusNavTitle')}
              </H3>
            </div>

            <ul className="my-library__nav-list">
              {hasBonusVideos
                && <MyLibraryNavItem
                  url={URL_PLAYLIST_BONUS_VIDEOS}
                  onClick={handleItemClick}
                  icon={<Film />}
                  text={staticText.get('videosTitle')}
                  location={location}
                />
              }
              {hasBonusEBooks
                && <MyLibraryNavItem
                  url={URL_PLAYLIST_BONUS_EBOOKS}
                  onClick={handleItemClick}
                  icon={<Book />}
                  text={staticText.get('eBooksTitle')}
                  location={location}
                />
              }
            </ul>
          </>
        }

        {(hasPurchasesVideos || hasPurchasesEBooks)
          && <>
            <div className="my-library__nav-heading">
              <H3 as={HEADING_TYPES.H5}>
                {staticText.get('purchasesNavTitle')}
              </H3>
            </div>

            <ul className="my-library__nav-list">
              {hasPurchasesVideos
                && <MyLibraryNavItem
                  url={URL_PLAYLIST_PURCHASES_VIDEOS}
                  onClick={handleItemClick}
                  icon={<Film />}
                  text={staticText.get('videosTitle')}
                  location={location}
                />
              }
              {hasPurchasesEBooks
                && <MyLibraryNavItem
                  url={URL_PLAYLIST_PURCHASES_EBOOKS}
                  onClick={handleItemClick}
                  icon={<Book />}
                  text={staticText.get('eBooksTitle')}
                  location={location}
                />
              }
            </ul>
          </>
        }
      </div>
    </div>
  )
}

MyLibraryNav.defaultProps = {
  userPurchases: {
    contentList: List(),
    assetsList: List(),
  },
  userBonuses: {
    contentList: List(),
    assetsList: List(),
  },
}

MyLibraryNav.propTypes = {
  defaultPlaylists: ImmutablePropTypes.list.isRequired,
  customPlaylists: ImmutablePropTypes.list.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  location: PropTypes.object.isRequired,
  onCreateClick: PropTypes.func.isRequired,
  userPurchases: PropTypes.object.isRequired,
  userBonuses: PropTypes.object.isRequired,
  title: PropTypes.string,
}

export default MyLibraryNav
